import React, { useEffect } from "react";
import "./subscriptionedit.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Topbar from "../../Global/topbar";
import SubscriptionForm from "./SubscriptionForm";

export default function SubscriptionEdit() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { data, edit2 } = state || {};

  const notify = () => {
    navigate("/admin/subscription");
  };
  useEffect(() => {
    if (!data) {
      navigate("/admin/subscription", { replace: true });
    }
  }, [data, navigate]);

  if (!data) {
    return null;
  }

  return (
    <div className="create-main-subscription">
      <div className="container-subscription">
        <Topbar />
        <div className="create-mid-subscription">
          <div className="back">
            {" "}
            <button onClick={notify} className="logout">
              {" "}
              <ArrowBackIcon style={{ fontSize: "2rem" }} />
            </button>
            <h1> Subscription Detail</h1>
          </div>
          <div>
            <button className="a-button" style={{ display: "none" }}>
              Dashboard
            </button>{" "}
            <Link to="/admin/subscription">Subscriptions List</Link> &#62;{" "}
            <a href={window.location.href}>Subscription Detail</a>
          </div>
        </div>
        <SubscriptionForm data={data} edit2={edit2} />
      </div>
    </div>
  );
}
